import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/sections/Header";
import { Hero } from "@/sections/Hero";
import { Features } from "@/sections/Features";
import { HowItWorks } from "@/sections/HowItWorks";
import { Stats } from "@/sections/Stats";
import { Testimonials } from "@/sections/Testimonials";
import { Store } from "@/sections/Store";
import { CTASection } from "@/sections/CTASection";
import { Footer } from "@/sections/Footer";
import SupportRoute from "@/pages/SupportRoute";
import AccountPage from "@/pages/AccountPage";

const Landing = () => (
    <div className="App" data-testid="landing-app">
        <Header />
        <main>
            <Hero />
            <Features />
            <HowItWorks />
            <Stats />
            <Testimonials />
            <Store />
            <CTASection />
        </main>
        <Footer />
    </div>
);

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/legal/:slug" element={<SupportRoute />} />
                    <Route path="/account" element={<AccountPage />} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
